module.exports = __webpack_public_path__ + "static/wilmaa_watch_care_thumb-62524ffebca36f641621c03bda599062.jpg";